<div class="sign-up-form-step-2">
  <div class="sign-up-form-explanation sign-up-form-swiper-container">
    <ng-container>
      <div class="sign-up-form-explanation-title" data-testid="account-info-title">
        {{ 'SIGNUP.SETUP.STEP_TWO_TRIAL.TRIAL_TITLE' | translate }}
      </div>
      <div class="sign-up-form-explanation-subtitle">
        {{ 'SIGNUP.SETUP.STEP_TWO_TRIAL.SUBTITLE' | translate }}
      </div>
    </ng-container>
  </div>
  <div class="form-container" #stepTwoFormContainer data-testid="stepTwo-form">
    <div>
      <!-- always show for step one of the form -->
      @if ((currentStep$ | async) !== ACCOUNT_INFO_STEP_TWO) {
        <div class="form-part-one">
          @if ((formFieldEnabled.firstName | async) || (formFieldEnabled.lastName | async)) {
            <div class="two-form-fields-block">
              @if (formFieldEnabled.firstName | async) {
                <glxy-form-field [required]="true">
                  <glxy-label>{{ 'SIGNUP.FIRST_NAME' | translate }}</glxy-label>
                  <input
                    matInput
                    #firstNameComponent
                    [formControl]="control('firstName')"
                    data-testid="firstName-input"
                    id="firstName"
                  />
                </glxy-form-field>
              }
              @if (formFieldEnabled.lastName | async) {
                <glxy-form-field [required]="true">
                  <glxy-label>{{ 'SIGNUP.LAST_NAME' | translate }}</glxy-label>
                  <input
                    matInput
                    [formControl]="control('lastName')"
                    data-testid="lastName-input"
                    id="lastName"
                  />
                </glxy-form-field>
              }
            </div>
          }
          @if (formFieldEnabled.password | async) {
            <glxy-form-field [required]="true">
              <glxy-label>{{ 'SIGNUP.PASSWORD' | translate }}</glxy-label>
              <input
                matInput
                [type]="passwordVisible ? 'text' : 'password'"
                [formControl]="control('password')"
                data-testid="password-input-component"
                id="password"
              />
              <button glxySuffix mat-icon-button type="button" (click)="togglePasswordVisibility()">
                <mat-icon>{{ passwordVisible ? 'visibility_off' : 'visibility' }}</mat-icon>
              </button>
              @if (submitMatcher.submitted && form.get('password')?.errors?.['minlength']) {
                <glxy-error>{{ 'SIGNUP.VALIDATION.PASSWORD_MIN_LENGTH' | translate }}</glxy-error>
              }
            </glxy-form-field>
          }
        </div>
      }
      @if ((currentStep$ | async) === ACCOUNT_INFO_STEP_TWO) {
        <div class="form-part-two">
          <google-map
            style="display: none"
            [options]="{ fullscreenControl: false, mapTypeControl: false }"
            (mapInitialized)="onMapReady($event)"
          ></google-map>
          <div class="two-form-fields-block">
            @if (formFieldEnabled.companyName | async) {
              <glxy-form-field [required]="true">
                <glxy-label>{{ 'SIGNUP.COMPANY_NAME' | translate }}</glxy-label>
                <input
                  id="companyName"
                  name="companyName"
                  matInput
                  [formControl]="control('companyName')"
                  [matAutocomplete]="auto"
                  (keyup)="companyOnFieldChange($event)"
                  data-testid="companyName-input"
                />
                @if (submitMatcher.submitted && form.get('companyName')?.hasError('required')) {
                  <glxy-error>
                    {{ 'COMMON.FIELD_REQUIRED' | translate: { fieldName: 'SIGNUP.COMPANY_NAME' | translate } }}
                  </glxy-error>
                }
              </glxy-form-field>
              <mat-autocomplete
                #auto="matAutocomplete"
                [displayWith]="companyDisplayValue"
                (optionSelected)="companyOnSelected($event.option.value)"
                class="company-options"
              >
                @for (location of locations; track location; let isLast = $last) {
                  <mat-option
                    [ngClass]="{
                      'autocomplete-suggestion': true,
                      'suggestion-not-found': isLast,
                    }"
                    [value]="location"
                  >
                    <span class="main-text">{{ location.mainText }}</span>
                    <br />
                    <span class="secondary-text">{{ location.secondaryText }}</span>
                  </mat-option>
                }
              </mat-autocomplete>
            }
            @if (formFieldEnabled.numberOfEmployees | async) {
              <glxy-form-field>
                <glxy-label>{{ 'SIGNUP.NUMBER_OF_EMPLOYEES' | translate }}</glxy-label>
                <mat-select
                  [formControl]="control('numberOfEmployees')"
                  required
                  data-testid="numberOfEmployees-input"
                  id="numberOfEmployees"
                >
                  @for (option of numberOfEmployeesOptions; track option.value) {
                    <mat-option [value]="option.value">
                      {{ option.label | translate }}
                    </mat-option>
                  }
                </mat-select>
              </glxy-form-field>
            }
          </div>
          <div class="two-form-fields-block">
            @if (formFieldEnabled.countrySearchControl | async) {
              @if (countryOptions$ | async; as countryOptions) {
                <glxy-form-field [required]="true" data-testid="country-field">
                  <glxy-label>{{ 'SIGNUP.COUNTRY' | translate }}</glxy-label>
                  <input
                    type="text"
                    attr.aria-label="{{ 'SIGNUP.COUNTRY' | translate }}"
                    matInput
                    [formControl]="control('countrySearchControl')"
                    [matAutocomplete]="countryAuto"
                    data-testid="country-input"
                    name="country"
                  />
                  @if (submitMatcher.submitted && form.get('countrySearchControl')?.hasError('required')) {
                    <glxy-error>
                      {{ 'COMMON.FIELD_REQUIRED' | translate: { fieldName: 'SIGNUP.COUNTRY' | translate } }}
                    </glxy-error>
                  }
                  @if (submitMatcher.submitted && form.get('countrySearchControl')?.hasError('invalidCountrySelection')) {
                    <glxy-error>{{ 'SIGNUP.VALIDATION.BAD_COUNTRY' | translate }}</glxy-error>
                  }
                </glxy-form-field>
                <mat-autocomplete
                  #countryAuto="matAutocomplete"
                  (optionSelected)="countrySelected($event.option.value)"
                >
                  @for (option of countryOptions; track option) {
                    <mat-option [value]="option.label" class="country__option">
                      <div class="country__option__text">{{ option.label }}</div>
                    </mat-option>
                  }
                </mat-autocomplete>
              } @else {
                <glxy-loading-spinner></glxy-loading-spinner>
              }
            }
            @if (formFieldEnabled.phoneNumber | async) {
              <glxy-phone-input
                #phoneNumberComponent
                required="true"
                [useGalaxyFormField]="true"
                [formControl]="control('phoneNumber')"
                data-testid="phoneNumber-input"
                id="phoneNumber"
              ></glxy-phone-input>
            }
          </div>
          <div class="two-form-fields-block">
            @if (formFieldEnabled.industry | async) {
              <glxy-form-field>
                <glxy-label>{{ 'SIGNUP.INDUSTRY' | translate }}</glxy-label>
                <mat-select [formControl]="control('industry')" required data-testid="industry-input">
                  @for (option of industryOptions; track option.value) {
                    <mat-option [value]="option.value">
                      {{ option.label | translate }}
                    </mat-option>
                  }
                </mat-select>
              </glxy-form-field>
            }
            @if (formFieldEnabled.websiteUrl | async) {
              <glxy-form-field>
                <glxy-label>{{ 'SIGNUP.WEBSITE_URL' | translate }}</glxy-label>
                <input
                  matInput
                  [formControl]="control('websiteUrl')"
                  data-testid="website-input"
                  id="website"
                />
                @if (submitMatcher.submitted && form.get('websiteUrl').errors?.['url'] !== undefined) {
                  <glxy-error>{{ 'SIGNUP.VALIDATION.INVALID_URL' | translate }}</glxy-error>
                }
              </glxy-form-field>
            }
          </div>
        </div>
      }
      <div class="sign-up-form-actions">
        <button
          data-action="step-two-submit"
          class="sign-up-form-cta full-width"
          mat-flat-button
          color="primary"
          type="button"
          (click)="onSubmit()"
          data-testid="signup-button"
        >
          <ng-container>
            {{ 'SIGNUP.BUTTONS.NEXT' | translate }}
          </ng-container>
        </button>
        <ng-template #buttonWithSpinner>
          <button mat-flat-button color="primary" class="sign-up-form-cta full-width">
            <span>
              <mat-progress-spinner mode="indeterminate" diameter="26"></mat-progress-spinner>
            </span>
          </button>
        </ng-template>
      </div>

      <div class="sign-up-form-privacy-policy">
        {{ 'SIGNUP.PRIVACY_POLICY_PRELINK' | translate }}
        <a data-action="step-two-privacy" href="https://www.vendasta.com/privacy-policy" target="_blank">
          {{ 'SIGNUP.PRIVACY_POLICY_LINK' | translate }}
        </a>
        {{ 'SIGNUP.PRIVACY_POLICY_POSTLINK' | translate }}
        <span [innerHTML]="'SIGNUP.RECAPTCHA_BRANDING' | translate"></span>
      </div>
    </div>
  </div>
  <ng-template #loadingForm>
    <div class="loading-container">
      <mat-progress-bar class="sign-up-progress" mode="indeterminate"></mat-progress-bar>
    </div>
  </ng-template>
</div>
